import { render, staticRenderFns } from "./resultTypeForm.vue?vue&type=template&id=7b2613c8&scoped=true&"
import script from "./resultTypeForm.vue?vue&type=script&lang=js&"
export * from "./resultTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./resultTypeForm.vue?vue&type=style&index=0&id=7b2613c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2613c8",
  null
  
)

export default component.exports